<template>
  <KCard
    :class="['base-cta-card', { 'base-cta-card--hovered': isHovered }]"
    v-on="{
      mouseover: onMouseOver,
      focusin: onMouseOver,
      mouseout: onMouseOut,
      focusout: onMouseOut
    }"
  >
    <template #content>
      <img
        :class="[
          'base-cta-card__image',
          { 'base-cta-card__image--left': arrows === 'left' },
          { 'base-cta-card__image--right': arrows === 'right' }
        ]"
        src="@/assets/images/arrows.png"
        alt="Arrows"
      />

      <div class="base-cta-card__container">
        <h3 class="base-cta-card__title">{{ title }}</h3>
        <slot name="buttons" />
      </div>
    </template>
  </KCard>
</template>

<script setup lang="ts">
import { KCard } from "@k2united/frontend_components";
import { ref } from "vue";

interface Props {
  title: string;
  arrows?: "left" | "right";
}

withDefaults(defineProps<Props>(), {
  arrows: "left"
});

const isHovered = ref(false);

const onMouseOver = () => {
  isHovered.value = true;
};
const onMouseOut = () => {
  isHovered.value = false;
};

defineExpose({ isHovered });
</script>

<style scoped lang="scss">
.base-cta-card {
  background: $color-industry-blue-default;
  overflow: hidden;
  position: relative;

  &--light {
    background: $color-industry-blue-default;
  }

  &--hovered {
    background: $color-industry-blue-bold;
  }

  &__image {
    opacity: 0.45;
    position: absolute;
    top: -154px;
    width: 243px;

    &--right {
      right: 35px;
    }
  }

  &__container {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    justify-content: space-between;
    position: relative;
    z-index: 1;

    @include tablet {
      flex-direction: row;
    }
  }

  &__title {
    @include body-bold;
    color: $color-text-inverse;
  }
}
</style>
